import { render } from "./AdminLink.vue?vue&type=template&id=3fabba27"
import script from "./AdminLink.vue?vue&type=script&lang=js"
export * from "./AdminLink.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__